import { ENDPOINTS } from '@philips-emr/hpms-health-insurance-commons';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { HttpService, SessionStorageService } from '@philips-emr/tws-core/lib/services';

import { HealthDeclarationLandingAliases as Aliases, FragmentNames } from '../../codegen';
import { BaseRoute } from '../../route';
import NoLoginBaseController from '../no-login-base-controller';

@Controller({ fragment: FragmentNames.HEALTH_DECLARATION_LANDING })
class HealthDeclarationLandingController extends NoLoginBaseController {
  @OnMount(Aliases.ROOT_COMPONENT)
  onRootMount(): void {
    this.noLoginThemeSetUp();
  }

  @OnMount(Aliases.LOADER_0)
  onMountFecth(): void {
    const { hash } = this.historyService.getCurrentRouteParams();

    void HttpService.get<{ seqInsuredDeclaration: string }>(ENDPOINTS.GET.HEALTH_DECLARATION_VALIDATE, { hash }).then(response => {
      if (!response.body) {
        this.historyService.push(BaseRoute.HEALTH_DECLARATION_INVALID);
        return;
      }
      const seqInsuredDeclaration = response.body.seqInsuredDeclaration;
      if (seqInsuredDeclaration !== undefined) {
        SessionStorageService.setItem('seqInsuredDeclaration', seqInsuredDeclaration);
        this.historyService.push(BaseRoute.HEALTH_DECLARATION_VALID, { hash });
      } else {
        this.historyService.push(BaseRoute.HEALTH_DECLARATION_INVALID);
      }
    }).catch(() => this.historyService.push(BaseRoute.HEALTH_DECLARATION_INVALID));
  }
}

export default HealthDeclarationLandingController;
